import request from "@/utils/request";
import Qs from "qs";

// 硬件组织--硬件组织列表
export function organLists(data) {
  return request({
    url: "/device/organ_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--添加硬件组织
export function addOrgan(data) {
  return request({
    url: "/device/add_organ",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--编辑硬件组织
export function editOrgan(data) {
  return request({
    url: "/device/edit_organ",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--删除硬件组织(支持批量)
export function delOrgan(data) {
  return request({
    url: "/device/del_organ",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--获取组织详情
export function organInfo(data) {
  return request({
    url: "/device/organ_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--选择硬件点位
export function selectDevices(data) {
  return request({
    url: "/device/select_devices",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--硬件人员列表
export function userLists(data) {
  return request({
    url: "/device/user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--添加硬件组织人员
export function addUsers(data) {
  return request({
    url: "/device/add_users",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 硬件组织--删除硬件组织人员（支持批量）
export function delUser(data) {
  return request({
    url: "/device/del_user",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--删除硬件组织人员（支持批量）
export function myDevices(data) {
  return request({
    url: "/device/get_my_devices",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--获得当前园区硬件厂商
export function get_manufacturers(data) {
  return request({
    url: "/common/get_manufacturers",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--根据类型获得当前园区权限或公司
export function get_source_rel(data) {
  return request({
    url: "/common/get_source_rel",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--获得当前园区硬件厂商所有点位
export function get_all_devices(data) {
  return request({
    url: "/common/get_all_devices",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取未添加至组织的硬件用户列表
export function get_device_users(data) {
  return request({
    url: "/common/get_device_users",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件组织--获得当前梯控设备具体的楼层信息
export function get_tikong_floors(data) {
  return request({
    url: "/common/get_device_tikongfloor",
    method: "post",
    data: Qs.stringify(data),
  });
}
